import { render } from "./Prequalification.vue?vue&type=template&id=084f13d4&scoped=true"
import script from "./Prequalification.vue?vue&type=script&lang=js"
export * from "./Prequalification.vue?vue&type=script&lang=js"

import "./Prequalification.vue?vue&type=style&index=0&id=084f13d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084f13d4"]])

export default __exports__